import {Component, Inject, Input, OnInit} from '@angular/core';
import {DropdownOption} from '../shared/models';
import {BenchmarkType} from '../shared/benchmark-types';
import {benchmarkChangedTo} from '../store/actions';
import {NgRedux, select} from '@angular-redux/store';
import {IAppState} from '../store/IAppState';
import {AnalyticsService, AnalyticsServiceToken} from '../analytics/analytics.service';
import {Observable} from 'rxjs';
import {benchmarkPercentileSeriesName} from '../shared/helpers';

@Component({
  selector: 'app-legend-benchmark-percentile',
  templateUrl: './legend-benchmark-percentile.component.html',
  styleUrls: ['./legend-benchmark-percentile.component.scss']
})
export class LegendBenchmarkPercentileComponent implements OnInit {

  @Input() defaultBenchmarkType: BenchmarkType | undefined;
  @Input() benchmarkToExclude: string[] | undefined;
  @Input() originClass: string;
  @Input() fromPdf: boolean;

  @select(['benchmark'])
  private readonly benchmarkType$: Observable<BenchmarkType>;

  benchmarkLabel: string;
  benchMarkType: BenchmarkType;
  BenchmarkType = BenchmarkType;

  benchmarkPercentiles: DropdownOption[] = [
    {value: BenchmarkType.Mean, name: benchmarkPercentileSeriesName(BenchmarkType.Mean)},
    {value: BenchmarkType.Percentile25th, name: benchmarkPercentileSeriesName(BenchmarkType.Percentile25th)},
    {value: BenchmarkType.Percentile50th, name: benchmarkPercentileSeriesName(BenchmarkType.Percentile50th)},
    {value: BenchmarkType.Percentile65th, name: benchmarkPercentileSeriesName(BenchmarkType.Percentile65th)},
    {value: BenchmarkType.Percentile75th, name: benchmarkPercentileSeriesName(BenchmarkType.Percentile75th)},
    {value: BenchmarkType.Percentile90th, name: benchmarkPercentileSeriesName(BenchmarkType.Percentile90th)},
  ];

  constructor(@Inject(AnalyticsServiceToken) private analyticsService: AnalyticsService,
              private ngRedux: NgRedux<IAppState>) {
  }

  ngOnInit() {
    if (this.benchmarkToExclude) {
      this.benchmarkToExclude.forEach(x => {
        this.benchmarkPercentiles = this.benchmarkPercentiles.filter(y => y.name !== x);
      });
    }
    this.benchmarkType$.subscribe((benchmarkTypeFromStore: BenchmarkType) => {
      let includes = false;
      this.benchmarkPercentiles.forEach(option => {
        if (option.value === benchmarkTypeFromStore) {
          includes = true;
        }
      });
      if (!includes) {
        this.benchMarkType = this.defaultBenchmarkType ? this.defaultBenchmarkType : BenchmarkType.Mean;
      } else {
        this.benchMarkType = benchmarkTypeFromStore;
      }
      const currentBenchmark = this.benchmarkPercentiles.find(x => x.value === this.benchMarkType);
      this.benchmarkLabel = currentBenchmark ? currentBenchmark.name : '';
    });
  }

  updateBenchmarkType(value: BenchmarkType): void {
    this.ngRedux.dispatch(benchmarkChangedTo(value));
    this.analyticsService.handleGoogleAnalytics('wRVU by Provider Graph Benchmark', 'Benchmark Change',
      BenchmarkType[value]);
  }

}
